import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { WishamNotification } from "types/notification.types"

type NotificationSlice = {
  notifications: WishamNotification[];
  unseenCount: number;
  hasMore: boolean;
  page: number
}

const initialState = {
  notifications: [],
  unseenCount: 0,
  hasMore: false,
  page: 1
} as NotificationSlice

export const notificationSlice = createSlice({
  name: "notificationSlice",
  initialState: initialState,
  reducers: {
    updateUnseenNotificationsCount: (state, action: PayloadAction<number>) => {
      state.unseenCount = structuredClone(action.payload)
    },
    updateNotifications: (state, action: PayloadAction<WishamNotification[]>) => {
      state.notifications = structuredClone(action.payload)
    },
    updateNotificationsHasMore: (state, action: PayloadAction<boolean>) => {
      state.hasMore = action.payload
    },
    increaseNotificationsPage: (state) => {
      state.page = state.page + 1
    },
    resetNotificationsPage: (state) => {
      state.page = initialState.page
    },
    resetNotificationSlice: () => structuredClone(initialState)
  }
})

export const {
  updateUnseenNotificationsCount,
  updateNotifications,
  updateNotificationsHasMore,
  increaseNotificationsPage,
  resetNotificationsPage,
  resetNotificationSlice
} = notificationSlice.actions

export default notificationSlice.reducer
